export const performanceTestingModule = {
  id: "performance-testing-enterprise",
  title: "Performance Testing & Load Validation", 
  description: "Conduct comprehensive performance testing to ensure enterprise applications scale under load.",
  content: `## Overview\nMaster performance testing strategies using tools like Artillery, JMeter, and k6 to validate application scalability and reliability.`,
  duration: 45
};